import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateMoneyPageAutomation as CreateMoneyPageAutomationMutation,
    CreateMoneyPageAutomationVariables,
    UrlAutomationCreateInput,
    GetMoneyPage,
    GetMoneyPageVariables,
} from 'nutshell-graphql-types';

import CREATE_MONEY_PAGE_AUTOMATION from '../mutations/create-money-page-automation.graphql';
import GET_MONEY_PAGE from '../queries/get-money-page.graphql';

export const useCreateMoneyPageAutomation = (): {
    createMoneyPageAutomation: (arg1: UrlAutomationCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createMoneyPageAutomation, {loading, error}] = useMutation<
        CreateMoneyPageAutomationMutation,
        CreateMoneyPageAutomationVariables
    >(CREATE_MONEY_PAGE_AUTOMATION);

    return {
        createMoneyPageAutomation: (input: UrlAutomationCreateInput) =>
            createMoneyPageAutomation({
                variables: {input},
                update: (cache, {data}) => {
                    if (!data || !data.maUrlAutomationCreate) {
                        return;
                    }

                    const {automation} = data.maUrlAutomationCreate;
                    if (!automation) {
                        return;
                    }

                    const cachedData = cache.readQuery<GetMoneyPage, GetMoneyPageVariables>({
                        query: GET_MONEY_PAGE,
                        variables: {id: input.urlId},
                    });

                    if (!cachedData || !cachedData.maUrl) {
                        return;
                    }

                    cache.writeQuery({
                        query: GET_MONEY_PAGE,
                        variables: {id: input.urlId},
                        data: {
                            ...cachedData,
                            maUrl: {
                                ...cachedData.maUrl,
                                automation,
                            },
                        },
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
